export class TimerModel {
    Id: number;
    Name: string;
    StartDate: Date = new Date();
    EndDate?: Date;

    get IsDone(): boolean {
        return this.EndDate != null;
    };

    get Ellapsed(): number {
        if (this.IsDone) {
            return this.EndDate.getTime() - this.StartDate.getTime();
        }
        return 0;
    }

    Finish():void{
        this.EndDate = new Date();
    }


}